import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import {
  Button,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Select,
} from 'antd';
import { withTranslation } from 'react-i18next';

import '@components/FilterForm.scss';
import { ListingStatusOptions } from '@constants/models/Listing';
import { SearchOutlined } from '@ant-design/icons';


class FilterForm extends React.Component {
  static propTypes = {
    // showPropertyName: PropTypes.bool,
    filteredInfo: PropTypes.shape({
      displayName: PropTypes.string,
      address: PropTypes.address,
      status: PropTypes.string,
      selectedUsageTypes: PropTypes.array,
    }).isRequired,
    loading: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
  }

  static defaultProps = {
    showPropertyName: false,
    loading: false,
    onSubmit: (filteredInfo) => {},
  }

  constructor(props) {
    super(props);
    this.state = {
      filteredInfo: { ...this.props.filteredInfo },
    };
    this.onChangeFilter = this.onChangeFilter.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.filteredInfo !== this.props.filteredInfo) {
      this.setState({
        filteredInfo: this.props.filteredInfo,
      });
    }
  }

  isDirty() {
    const keys = Object.keys(this.state.filteredInfo);
    return keys.some((key) => this.props.filteredInfo[key] !== this.state.filteredInfo[key]);
  }

  onChangeFilter(key, value) {
    this.setState({
      filteredInfo: {
        ...this.state.filteredInfo,
        [key]: value,
      },
    });
  }

  onSubmit() {
    this.props.onSubmit(this.state.filteredInfo);
  }

  getFormItems() {
    const items = [{
      label: this.props.t("shared.Status"),
      shouldRender: true,
      span: 8,
      renderChildren: () => (
        <Radio.Group
          onChange={ (e) => this.onChangeFilter('status', e.target.value) }
          value={ this.state.filteredInfo.status }
        >
          {
            Object.values(ListingStatusOptions).map((listingStatusOption) => (
              <Radio.Button key={ listingStatusOption.value } value={ listingStatusOption.value }>
                { this.props.t(listingStatusOption.ttextKey) }
              </Radio.Button>
            ))
          }
        </Radio.Group>
      )
    }, {
      label: null,
      shouldRender: true,
      span: 8,
      renderChildren: () => (
        <Button
          type="primary"
          icon={<SearchOutlined />}
          disabled={ !this.isDirty() }
          loading={ this.props.loading }
          onClick={ this.onSubmit }
        >
          { this.props.t("actions.Search") }
        </Button>
      ),
    }];
    return items.filter(({ shouldRender }) => { return shouldRender }).map((item, index) => {
      return (
        <Col span={ item.span || 8 } key={ index.toString() }>
          <Form.Item
            label={ item.label }
            labelCol={{ flex: "80px" }}
            wrapperCol={{ flex: "auto" }}
            style={{ marginBottom: 0 }}
          >
            { item.renderChildren() }
          </Form.Item>
        </Col>
      )
    });
  }

  render() {
    return (
      <div style={{ margin: 0, padding: '0 0 10px' }}>
        <Form className="ant-advanced-search-form" layout="horizontal">
          <Row
            gutter={ 24 }
            justify="space-between"
          >
            { this.getFormItems() }
          </Row>
        </Form>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  return {};
}

const mapDispatchToProps = (dispatch, props) => {
  return {
  };
}

export default withTranslation('common')(connect(mapStateToProps, mapDispatchToProps)(FilterForm));
